var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.StuartService.stuartMsg
    ? _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-xs-12 text-danger text-left" }, [
          _c("p"),
          _vm._v(" "),
          _c("b", [_vm._v(_vm._s(_vm.StuartService.stuartMsg))]),
          _vm._v(" "),
          _c("i", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.StuartService.stuartProcessing,
                expression: "StuartService.stuartProcessing",
              },
            ],
            staticClass: "loading",
          }),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }